module.exports = __webpack_public_path__ + "img/ThomasCook-icon.18355614.png";